import { ALL_FOLDER_ID } from '@wix/da-url';
import { GallectionType, GallectionSortOrder } from '../../types/gallection';

export const FOLDER_DEVIATIONS_STREAM_GROUP_ID = 'folder-deviations';

export const DEVIATIONS_PER_FETCH_COUNT = 24;

export const STREAM_PARAM_TYPE_FETCHING_PAUSED = 'fetching_paused';

export const getFolderDeviationsStreamId = (
  gallectionType: GallectionType,
  folderId,
  sortOrder = GallectionSortOrder.NEWEST
) => {
  const params = [gallectionType, folderId];

  if (folderId === ALL_FOLDER_ID) {
    params.push(sortOrder);
  }

  return `${FOLDER_DEVIATIONS_STREAM_GROUP_ID}-${params.join('-')}`;
};

export const getFolderDeviationsStreamParams = (
  gallectionType: GallectionType,
  folderId,
  sortOrder = GallectionSortOrder.NEWEST
) => {
  const params = { folderId, gallectionType } as any;
  if (folderId === ALL_FOLDER_ID) {
    params.sortOrder = sortOrder;
  }

  return params;
};

export const DEVIATION_SEARCH_RESULTS_STREAM_ID = 'deviation_search_results';
export const FAVOURITES_SEARCH_RESULTS_STREAM_ID = 'favourites_search_results';
